module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "nav-item",
    class: {
      'nav-item_wide': _vm.wide
    },
    on: {
      "mouseleave": function($event) {
        !_vm.checkMobile.any ? _vm.mouseLeave($event) : ''
      },
      "mouseover": function($event) {
        !_vm.checkMobile.any ? _vm.mouseEnter($event) : ''
      }
    }
  }, [_c('ext-link', {
    staticClass: "nav-item-link",
    class: {
      'nav-item-link_big': _vm.wide, 'nav-item-link_sublist': _vm.showSubList
    },
    style: (_vm.sectionMenuStyle),
    attrs: {
      "to": _vm.to,
      "prevent-default": _vm.needPrevent,
      "external": _vm.external,
      "target": _vm.target
    },
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "nav-item-link-text",
    class: {
      multiline: Array.isArray(_vm.text) && _vm.text.length > 1
    },
    domProps: {
      "innerHTML": _vm._s(_vm.textOut)
    }
  })]), (_vm.items && _vm.items.length && _vm.showSubList) ? _c('sub-list', {
    staticClass: "sublist",
    attrs: {
      "items": _vm.items,
      "level": Number(this.level) + 1,
      "max-level": _vm.maxLevel
    }
  }, [(_vm.checkMobile.mobile) ? _c('div', {
    attrs: {
      "slot": "subListMobile"
    },
    slot: "subListMobile"
  }, [_c('span', {
    staticClass: "top-level-btn",
    on: {
      "click": function($event) {
        _vm.showSubList = false
      }
    }
  }), _c('ext-link', {
    staticClass: "nav-item-link",
    attrs: {
      "to": _vm.to
    }
  }, [_c('span', {
    staticClass: "nav-item-link-text",
    domProps: {
      "innerHTML": _vm._s(_vm.textOut)
    }
  })])], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ec42ac8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/private/Item.vue
// module id = 8e8cffcf42905b56806e
// module chunks = 0